/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function LaunchIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "launch", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M15 5.5H5.5V19.5H19.5V10", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M21.5 3.5L11.5 13.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M17 3.5H21.5V8", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(LaunchIcon);
export default ForwardRef;
//# sourceMappingURL=launchIcon.js.map